import { render } from "./AccountProfileType.vue?vue&type=template&id=9e283362&scoped=true"
import script from "./AccountProfileType.vue?vue&type=script&lang=js"
export * from "./AccountProfileType.vue?vue&type=script&lang=js"

import "./AccountProfileType.vue?vue&type=style&index=0&id=9e283362&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e283362"]])

export default __exports__